import { useState, useEffect } from 'react';
import AppLayout from '@/components/AppLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
// Level 4.5: Proactive suggestions disabled
import { AgentGoalsDashboard } from '@/components/agent/AgentGoalsDashboard';
import { AgentAnalyticsDashboard } from '@/components/agent/AgentAnalyticsDashboard';
import { supabase } from '@/integrations/supabase/client';
import { Brain, Target, BarChart3, Bell } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

export default function AgentDashboard() {
  const { orgId, loading: authLoading } = useAuth();

  if (authLoading || !orgId) {
    return (
      <AppLayout>
        <div className="flex items-center justify-center h-full">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <Brain className="h-8 w-8 text-primary" />
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Agent Control Center</h1>
            <p className="text-muted-foreground">
              Level 4.5 reactive agent with memory, analytics, and goal tracking
            </p>
          </div>
        </div>

        <Tabs defaultValue="analytics" className="space-y-6">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="analytics" className="flex items-center gap-2">
              <BarChart3 className="h-4 w-4" />
              Analytics
            </TabsTrigger>
            <TabsTrigger value="goals" className="flex items-center gap-2">
              <Target className="h-4 w-4" />
              Goals
            </TabsTrigger>
          </TabsList>

          <TabsContent value="analytics">
            <AgentAnalyticsDashboard orgId={orgId} />
          </TabsContent>

          <TabsContent value="goals">
            <AgentGoalsDashboard orgId={orgId} />
          </TabsContent>
        </Tabs>
      </div>
    </AppLayout>
  );
}
